<template>
  <div>
    <v-dialog
      :value="show"
      max-width="500px"
      @input="closeModal">
      <v-card>
        <v-card-title class="k-orange-linear">
          <v-layout row wrap>
            <v-flex md9>
              <div class="display-1 text-capitalize">
                {{ customerName }}
              </div>
            </v-flex>
            <v-flex md3>
              <v-layout row wrap justify-end>
                <v-btn icon @click="editCustomer">
                  <v-icon color="white">
                    fas fa-pencil-alt
                  </v-icon>
                </v-btn>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs6 mb-3>
              <v-list-tile>
                <v-list-tile-avatar>
                  <v-icon>fas fa-user</v-icon>
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title>{{ customer.name || 'Sin especificar' }}</v-list-tile-title>
                  <v-list-tile-sub-title>Nombre</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-flex>
            <v-flex xs6>
              <v-list-tile>
                <v-list-tile-avatar>
                  <v-icon>fas fa-address-card</v-icon>
                </v-list-tile-avatar>
                <v-list-tile-content>
                      <v-list-tile-title>{{ customer.fiscal_id || 'Sin especificar' }}</v-list-tile-title>
                      <v-list-tile-sub-title>RUT/DNI/CI</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-flex>
            <v-flex xs6>
              <v-list-tile justify-center>
                <v-list-tile-avatar>
                  <v-icon>fas fa-user-circle</v-icon>
                </v-list-tile-avatar>
                <v-list-tile-content>
                      <v-list-tile-title>{{ customer.account || 'Sin especificar' }}</v-list-tile-title>
                      <v-list-tile-sub-title>Cuenta</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-flex>
            <v-flex xs6>
              <v-list-tile justify-center>
                <v-list-tile-avatar>
                  <v-icon>fas fa-user-circle</v-icon>
                </v-list-tile-avatar>
                <v-list-tile-content>
                      <v-list-tile-title>{{ customerStatus(customer.customer_status_id).status || 'Sin especificar' }}</v-list-tile-title>
                      <v-list-tile-sub-title>Estado</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-flex>
            <v-flex xs12>
              <v-list-tile justify-center>
                <v-list-tile-avatar>
                  <v-icon>fas fa-user-circle</v-icon>
                </v-list-tile-avatar>
                <v-list-tile-content>
                      <v-list-tile-title>{{ subStatus(customer.sub_status_id).name || 'Sin especificar' }}</v-list-tile-title>
                      <v-list-tile-sub-title>Sub-estado</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs12>
              <v-list two-line class="pa-0">
                <template>
                  <v-layout>
                    <v-flex md11>
                      <v-subheader>
                        Teléfono(s)
                      </v-subheader>
                    </v-flex>
                    <v-flex class="pt-2">
                      <v-btn small depressed fab class="k-orange mr-0 plus-button" @click="showEditContact('phone', 0)">
                        <v-icon small>
                          fas fa-plus
                        </v-icon>
                      </v-btn>
                    </v-flex>
                  </v-layout>
                  <template v-if="phones && phones.length">
                    <scrollbar >
                      <div class="p-relative contact-dtl-wrapper" >
                        <v-list-tile v-for="phone in phones" :key="`phone-${phone.id}`" @click="showEditContact('phone',phone.id)">
                          <v-list-tile-action>
                            <v-icon>fas fa-phone fa-rotate-90</v-icon>
                          </v-list-tile-action>
                          <v-list-tile-content>
                            <v-list-tile-title>{{ phone.phone }}</v-list-tile-title>
                            <v-list-tile-sub-title>{{ phoneTypes[phone.type - 1] }}</v-list-tile-sub-title>
                          </v-list-tile-content>
                          <v-list-tile-action >
                            <v-layout row wrap>
                              <v-flex  md3 mr-2>
                                <v-tooltip bottom>
                                  <v-icon
                                    :color="findStatus(phone).color"
                                    slot="activator"
                                    small>
                                    {{ findStatus(phone).icon }}
                                  </v-icon>
                                  <span>
                                    {{ findStatus(phone).name }}
                                  </span>
                                </v-tooltip>
                              </v-flex>
                            </v-layout>
                          </v-list-tile-action>
                        </v-list-tile>
                      </div>
                    </scrollbar>
                  </template>
                  <template v-else>
                    <v-layout>
                      <v-flex class="text-xs-center">
                        <v-icon small class="mr-2 d-inline-block">
                          fas fa-exclamation-circle
                        </v-icon>
                        <p class="d-inline-block">
                          No hay telefonos
                        </p>
                      </v-flex>
                    </v-layout>
                  </template>
                </template>
                <template >
                  <v-layout row wrap>
                    <v-flex md11>
                      <v-subheader>
                        Email(s)
                      </v-subheader>
                    </v-flex>
                    <v-flex class="pt-2">
                      <v-btn small depressed fab class="k-orange mr-0 plus-button" @click="showEditContact('email',0)">
                        <v-icon small>
                          fas fa-plus
                        </v-icon>
                      </v-btn>
                    </v-flex>
                  </v-layout>
                  <template v-if="emails && emails.length">
                    <scrollbar >
                      <div class="p-relative contact-dtl-wrapper">
                        <v-list-tile v-for="email in emails" :key="`email-${email.id}`" @click="showEditContact('email',email.id)">
                          <v-list-tile-action>
                            <v-icon>fas fa-envelope</v-icon>
                          </v-list-tile-action>
                          <v-list-tile-content>
                            <v-list-tile-title>{{ email.email }}</v-list-tile-title>
                            <v-list-tile-sub-title>{{ emailTypes[email.type - 1] }}</v-list-tile-sub-title>
                          </v-list-tile-content>
                          <v-list-tile-action>
                            <v-layout>
                              <v-flex md3>
                                <v-tooltip bottom class="pr-1">
                                  <v-icon
                                    :color="findStatus(email).color"
                                    slot="activator"
                                    small>
                                    {{ findStatus(email).icon }}
                                  </v-icon>
                                  <span>
                                    {{ findStatus(email).name }}
                                  </span>
                                </v-tooltip>
                              </v-flex>
                            </v-layout>
                          </v-list-tile-action>
                        </v-list-tile>
                      </div>
                    </scrollbar>
                  </template>
                  <template v-else>
                    <v-layout>
                      <v-flex class="text-xs-center">
                        <v-icon small class="mr-2 d-inline-block">
                          fas fa-exclamation-circle
                        </v-icon>
                        <p class="d-inline-block">
                          No hay emails
                        </p>
                      </v-flex>
                    </v-layout>
                  </template>
                </template>
              </v-list>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions class="pr-2">
          <v-spacer></v-spacer>
          <v-btn color="black darken-1" flat @click="closeModal">
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <customer-update
      :show="showCustomerUpdate"
      :customer="customer"
      @customer-updated="customerUpdate"
      @close="showCustomerUpdate = false">
    </customer-update>
    <edit-method 
      :show="editContact"
      :customer="customer"
      :method="method"
      @contact-added="contactAdded"
      @contact-updated="contactUpdated"
      @close="editContact = false">
    </edit-method>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapGetters } from 'vuex';
import Scrollbar from 'vue-perfect-scrollbar';
import CustomerUpdate from '@/components/customer/CustomerUpdate';
import contacDtlMixin from '@/mixins/contactDtl';
import EditMethod from './EditMethod';

export default {
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    customer: {
      type: Object,
      required: true,
    },
  },
  components: {
    Scrollbar,
    EditMethod,
    CustomerUpdate,
  },
  mixins: [
    contacDtlMixin,
  ],
  mounted() {
    this.fetch();
  },
  data() {
    return {
      emails: [],
      phones: [],
      editContact: false,
      showCustomerUpdate: false,
      method: {
        id: 0,
        type: 'email',
      },
    };
  },
  computed: {
    customerName() {
      return String(this.customer.name || this.customer.first_name || 'Desconocido').toLowerCase();
    },
    ...mapGetters([
      'customerStatus',
      'subStatus',
    ]),
  },
  methods: {
    fetch() {
      this.axios.get(`/customers/${this.customer.id}/emails`).then(({ data }) => {
        this.emails = data;
      });
      this.axios.get(`/customers/${this.customer.id}/phones`).then(({ data }) => {
        this.phones = data;
      });
    },
    showEditContact(type, id) {
      this.method.id = id;
      this.method.type = type;
      this.editContact = true;
    },
    deleteContact() {
      this.$emit('delete-contact', this.contact);
      this.$emit('close');
    },
    customerUpdate(customer) {
      this.$emit('customer-updated', customer);
    },
    contactAdded($event) {
      this[`${$event.type}s`].push($event.value);
      this.$emit('contact-added', $event);
    },
    contactUpdated($event) {
      const index = this[`${$event.type}s`].findIndex(item => item.id === $event.value.id);
      Vue.set(this[`${$event.type}s`], index, $event.value);
      this.$emit('contact-updated', $event);
    },
    editCustomer() {
      this.showCustomerUpdate = true;
    },
    findStatus(type) {
      return this.contactDtlstatus.find(item => item.name === type.status);
    },
    closeModal() {
      this.$emit('close');
    },
  },
};
</script>

<style>
.contact-dtl-wrapper {
  height: 80px;
}
.call-button {
  height: 18px !important;
  width: 18px !important;
}
.call-button i {
  font-size: 10px !important;
}
.plus-button{
    height: 20px!important;
    width: 20px!important;
}
.plus-button i{
    font-size: 13px!important;
}

.ps> .ps__scrollbar-x-rail, .ps> .ps__scrollbar-y-rail{
   opacity: 0.6;
}
</style>


// WEBPACK FOOTER //
// src/components/customer/EditCustomerModal.vue